const constants = {
    ORGANIZATION: {
        BRANDING_MAX_COLORS: 2,
        BRANDING_CUSTOM_URL_LENGTH: 10,
        S3_FILE_URL_VALIDITY: 900
    },
    RINGSIDE_PRO_ORGANIZATION: {
        id: "ringSidePro",
        name: "RingSide Pro",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    ADD_NEW_ORGANIZATION: {
        id: "addNewOrganization",
        name: "Add New Organization",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    AEL_ORGANIZATION: {
        id: "e05fc919-2793-4ead-acef-3f6efb584b67",
        name: "Athletic Equestrian League",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    RHSC_ORGANIZATION: {
        id: "ba239ae1-f8ee-4bb7-bdf1-8a089f49746e",
        name: "RHSC",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    MOHSS_ORGANIZATION: {
        id: "376d94dc-4f82-43b4-ac28-b2d193b43b06",
        name: "Maryland Open Horse Show Series",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    IHSA_ORGANIZATION: {
        id: "24611fd5-9648-40f3-9e84-7d10771c2625",
        name: "Intercollegiate Horse Shows Association",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    SHOT_ORGANIZATION: {
        id: "e2ae09aa-25cd-47a8-85c4-6d75bc469e77",
        name: "Stock Horse of Texas",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    Coveside_ORGANIZATION: {
        id: "9b544253-19a5-425e-956f-8b50414818c1",
        name: "Coveside Show Series - Canadian Horse Shows",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    Meadowlarke_ORGANIZATION: {
        id: "ca0f3c29-5267-49e6-8a8f-d7ced32e9b90",
        name: "Meadowlarke North - Canadian Horse Shows",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    CEDAR_VALLEY_RIDERS_ORGANIZATION: {
        id: "a603e82a-a76b-4c76-bcbc-d6527ef878bc",
        name: "Cedar Valley Riders",
        createdBy: "",
        createdOn: "",
        updatedOn: ""
    },
    COLORS: {
        PRIMARY: "#3a4454",
        SECONDARY: "#425974",
        TERTIARY: "#73a4d3"
    },
    SEASON_STATUS: {
        ACTIVE: "ACTIVE",
        IN_ACTIVE: "IN ACTIVE"
    },
    MEMBERSHIP: {
        MEMBERSHIP_ID_VALUES_ERROR_MSG: "The Membership Id Values are not formatted properly. You can include a list of increasing number values or ranges separated by commas.",
        MEMBERSHIP_NEXT_AVAILABLE_ID_ERR_MSG_1: "Please adjust the Membership Id Values. You cannot remove values that have already been assigned to memberships.",
        MEMBERSHIP_NEXT_AVAILABLE_ID_ERR_MSG_2: "Please adjust the Membership Id Values. You cannot add values that are less than the Next Unused Membership Id.",
        ONLINE_APPLICATION: {
            YES: "Yes",
            NO: "No"
        },
        START_MEMBERSHIP_ON_PURCHASE_DATE: {
            YES: "Yes",
            NO: "No"
        },
        GRADE_LEVEL: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        ONLINE_PAYMENT_FEE: 1.50, //Currently will leave this as $1.50 as RHSC tests the membership system
        APPLICATION_STATUS: {
            IN_PROGRESS: "in_progress",
            TRIAL: "trial",
            COMPLETE: "complete",
            IN_PROGRESS_TEXT: "In Progress",
            TRIAL_Text: "Trial",
            COMPLETE_TEXT: "Completed",
            APPLICATION_INCOMPLETE: "Application Incomplete",
            ACTIVE: "Active",
            EXPIRED: "Expired"

        },
        APPLICATION_STAGES: {
            BASIC: "Basic",
            UPLOADS: "Uploads",
            WAIVERS: "Waivers",
            PAYMENT: "Payment",
            CONFIRMATION: "Confirmation"
        },
        APPLICATION_EDIT_STAGES: {
            GROUP: "Group",
            BASIC: "Basic",
            CONTACT: "Contact",
            UPLOADS: "Uploads",
            WAIVERS: "Waivers",
            PAYMENT: "Payment"
        }
    }
};

export default constants;